import AwesomeDebouncePromise from 'awesome-debounce-promise';
import { isEmpty, some, pick } from 'lodash-es';
import axios, { AxiosError } from 'axios';
import React, { useState, useCallback, useEffect } from 'react';
import { getErrorMessagesFromResponse } from '../../../../common/utils';
import { Alert } from '../../../../components/Alert';
const fetchTax = AwesomeDebouncePromise(async (data) => {
    var _a;
    const requestData = {
        account_type: data.accountType,
        address: data.address,
        country: data.country,
        city: data.city,
        state: data.state,
        zipcode: data.zipcode,
        plan: (_a = data.selectedPlan) === null || _a === void 0 ? void 0 : _a.id,
        promo_code: data.promoCode.code,
    };
    return (await axios.post('/api/taxes', requestData)).data;
}, 500);
export function TaxField({ fields, updateFields }) {
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState([]);
    const searchTax = useCallback(async () => {
        try {
            setLoading(true);
            const taxFound = await fetchTax(pick(fields, ['accountType', 'address', 'country', 'city', 'state', 'zipcode', 'selectedPlan', 'promoCode']));
            updateFields({ taxes: taxFound.amount_to_collect });
            setErrors([]);
        }
        catch (error) {
            if (error instanceof AxiosError) {
                setErrors(getErrorMessagesFromResponse(error));
            }
            else if (error instanceof Error) {
                setErrors([error.message]);
            }
            else {
                setErrors(['Unknown Error']);
            }
            updateFields({ taxes: null });
            throw error;
        }
        finally {
            setLoading(false);
        }
    }, [fields, fetchTax, updateFields, setLoading]);
    useEffect(() => {
        var _a;
        if (some([
            fields.accountType,
            fields.address,
            fields.country,
            fields.city,
            fields.state,
            fields.zipcode,
            fields.selectedPlan,
        ], isEmpty)) {
            updateFields({ taxes: null });
        }
        else if ((_a = fields.selectedPlan) === null || _a === void 0 ? void 0 : _a.is_trial) {
            updateFields({ taxes: 0 });
        }
        else {
            searchTax();
        }
    }, [
        fields.accountType,
        fields.address,
        fields.country,
        fields.city,
        fields.state,
        fields.zipcode,
        fields.selectedPlan,
        fields.promoCode.discountPercentage,
    ]);
    return (React.createElement("div", { className: 'payment-field' },
        React.createElement("div", { className: 'label' }, "Taxes:"),
        React.createElement(Alert, { messages: errors, type: "error" }),
        React.createElement("div", { className: 'value' }, loading || fields.taxes === null ?
            React.createElement("span", null, "Calculating...") :
            React.createElement("span", null,
                "+ $",
                fields.taxes.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })))));
}
